import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'app-basic',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.scss'],
})
export class ViewModuleComponent {}
